import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { ColorDefinition } from './chrome-picker-selector';

@Injectable({
    providedIn: 'root',
})
export class ColorPickerService {
    colorSelected$ = new Subject<{ idColorPicker: string; colorDefinition: ColorDefinition[] | null }>();

    setActualColorValue(idColorPicker: string, colorDefinition: ColorDefinition[] | null): void {
        this.colorSelected$.next({ idColorPicker, colorDefinition });
    }
}
